import { Card, Form, Input, DatePicker, Select, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { caseAPI } from "../services/api";

const { TextArea } = Input;
const { Option } = Select;

const NewCase: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      const caseData = {
        ...values,
        filing_date: values.filing_date.format("YYYY-MM-DD"),
      };

      const newCase = await caseAPI.create(caseData);
      message.success("Caso creado exitosamente");
      navigate(`/case/${newCase.case_id}`);
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.detail || error.message || "Error desconocido";
      message.error(`Error al crear el caso: ${errorMessage}`);
      console.error("Error creating case:", error);
      console.error("Error details:", error.response?.data);
    }
  };

  return (
    <div>
      <h1>Crear Nuevo Caso</h1>
      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            status: "active",
            priority: "medium",
          }}
        >
          <Form.Item
            label="Número de Caso"
            name="case_number"
            rules={[{ required: true, message: "Ingresa el número de caso" }]}
          >
            <Input placeholder="Ej: 701102022500681" />
          </Form.Item>

          <Form.Item
            label="Tipo de Caso"
            name="case_type"
            rules={[{ required: true, message: "Selecciona el tipo de caso" }]}
          >
            <Select placeholder="Selecciona el tipo">
              <Option value="Allanamiento de Domicilio">
                Allanamiento de Domicilio
              </Option>
              <Option value="Robo Agravado">Robo Agravado</Option>
              <Option value="Abigeato Agravado">Abigeato Agravado</Option>
              <Option value="Lesiones Graves">Lesiones Graves</Option>
              <Option value="Amenazas">Amenazas</Option>
              <Option value="Asociación Delictuosa">
                Asociación Delictuosa
              </Option>
              <Option value="Otro">Otro</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Jurisdicción"
            name="jurisdiction"
            rules={[{ required: true, message: "Ingresa la jurisdicción" }]}
          >
            <Input placeholder="Ej: Santa Cruz - FELCC Tusequis" />
          </Form.Item>

          <Form.Item
            label="Fecha de Presentación"
            name="filing_date"
            rules={[{ required: true, message: "Selecciona la fecha" }]}
          >
            <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
          </Form.Item>

          <Form.Item label="Estado" name="status">
            <Select>
              <Option value="active">Activo</Option>
              <Option value="closed">Cerrado</Option>
              <Option value="appealed">En Apelación</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Prioridad" name="priority">
            <Select>
              <Option value="low">Baja</Option>
              <Option value="medium">Media</Option>
              <Option value="high">Alta</Option>
              <Option value="urgent">Urgente</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Resumen del Caso"
            name="summary"
            rules={[{ required: true, message: "Ingresa un resumen del caso" }]}
          >
            <TextArea
              rows={6}
              placeholder="Describe brevemente los hechos del caso..."
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" block>
              Crear Caso
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default NewCase;
